import { render, staticRenderFns } from "./book-collect.vue?vue&type=template&id=52f000a5&scoped=true"
import script from "./book-collect.vue?vue&type=script&lang=js"
export * from "./book-collect.vue?vue&type=script&lang=js"
import style0 from "./book-collect.vue?vue&type=style&index=0&id=52f000a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f000a5",
  null
  
)

export default component.exports